import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get knowledge by organization that I'm a member of
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetMyKnowledge = packet => {
  return {
    type: 'REQUEST_GET_MY_KNOWLEDGE',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetMyKnowledgeSuccess = data => ({
  type: 'RECEIVE_GET_MY_KNOWLEDGE_SUCCESS',
  data
})

export const receiveGetMyKnowledgeFail = data => ({
  type: 'RECEIVE_GET_MY_KNOWLEDGE_FAIL',
  data
})

export const tryToGetMyKnowledge = packet => (dispatch, getState) => {

  dispatch(requestGetMyKnowledge(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/knowledge/org/' + packet.org_id + '/mine', {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetMyKnowledgeSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetMyKnowledgeFail({errors:e, lastSubmit: packet}));
    })
}
